import { ThemeMode } from '../../enums';
export const createGeneralSlice = (set, get) => ({
    defaultThemeMode: undefined,
    setDefaultThemeMode: (themeMode) => set(() => {
        let mode = ThemeMode.SYSTEM;
        switch (themeMode) {
            case 'dark':
            case ThemeMode.DARK:
                mode = ThemeMode.DARK;
                break;
            case 'light':
            case ThemeMode.LIGHT:
                mode = ThemeMode.LIGHT;
                break;
            case 'system':
            case ThemeMode.SYSTEM:
                mode = ThemeMode.SYSTEM;
                break;
            default:
                break;
        }
        return {
            defaultThemeMode: mode,
            themeMode: get().themeMode === undefined ? mode : get().themeMode,
        };
    }),
    themeMode: undefined,
    setThemeMode: (themeMode) => set(() => {
        return {
            themeMode: themeMode || get().themeMode || get().defaultThemeMode,
        };
    }),
});
//# sourceMappingURL=general.js.map